import React from 'react';
import {
  formatReportAngle,
  formatReportCoord,
  formatReportDepth,
} from '../../../utils/dailyReport/drillingInProgressForReport';
import { REPORT_PRINT_THEME, REPORT_PRINT_TYPO } from '../../../utils/dailyReport/reportPrintTheme';
import QuicklogHoleBar from '../quicklog/QuicklogHoleBar';
import PrintQuicklogStriplog from './PrintQuicklogStriplog';

const HEADER_COLUMNS = 5;
const LEFT_PANEL_WIDTH = '50%';

function HeaderCell({ label, value, colSpan = 1 }) {
  return (
    <td
      colSpan={colSpan}
      style={{
        padding: '3px 5px',
        border: `1px solid ${REPORT_PRINT_THEME.border}`,
        background: REPORT_PRINT_THEME.backgroundAlt,
        verticalAlign: 'top',
      }}
    >
      {label ? (
        <div
          style={{
            ...REPORT_PRINT_TYPO.label,
            color: REPORT_PRINT_THEME.textLight,
            textTransform: 'uppercase',
            letterSpacing: '0.03em',
            marginBottom: '1px',
            fontSize: '7.5px',
            lineHeight: 1.15,
            whiteSpace: 'normal',
          }}
        >
          {label}
        </div>
      ) : null}
      <div
        style={{
          ...REPORT_PRINT_TYPO.body,
          color: REPORT_PRINT_THEME.text,
          fontWeight: 600,
          lineHeight: 1.2,
          fontSize: '9.5px',
          wordBreak: 'break-word',
        }}
      >
        {value}
      </div>
    </td>
  );
}

const PrintDrillingInProgressHole = ({
  dataset,
  purpose,
  planned_depth,
  target_description,
  actual_depth,
  easting,
  northing,
  azimuth,
  dip,
  geologist,
  quicklogRows = [],
  listVisualMaps = null,
}) => {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        minHeight: 0,
        height: '100%',
        gap: '10px',
        background: REPORT_PRINT_THEME.background,
        color: REPORT_PRINT_THEME.text,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          width: LEFT_PANEL_WIDTH,
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          gap: '6px',
        }}
      >
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            tableLayout: 'fixed',
          }}
        >
          <colgroup>
            {Array.from({ length: HEADER_COLUMNS }, (_, index) => (
              <col key={index} style={{ width: `${100 / HEADER_COLUMNS}%` }} />
            ))}
          </colgroup>
          <tbody>
            <tr>
              <HeaderCell label="Dataset" value={dataset || '—'} />
              <HeaderCell label="Purpose" value={purpose || '—'} />
              <HeaderCell label="Planned (m)" value={formatReportDepth(planned_depth)} />
              <HeaderCell label="Actual (m)" value={formatReportDepth(actual_depth)} />
              <HeaderCell label="Target" value={target_description || '—'} />
            </tr>
            <tr>
              <HeaderCell label="Easting" value={formatReportCoord(easting)} />
              <HeaderCell label="Northing" value={formatReportCoord(northing)} />
              <HeaderCell label="Azimuth" value={formatReportAngle(azimuth)} />
              <HeaderCell label="Dip" value={formatReportAngle(dip)} />
              <HeaderCell label="Geologist" value={geologist || '—'} />
            </tr>
          </tbody>
        </table>

        <div
          style={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            border: `1px solid ${REPORT_PRINT_THEME.border}`,
            borderRadius: '4px',
            overflow: 'hidden',
            background: REPORT_PRINT_THEME.background,
          }}
        >
          <QuicklogHoleBar
            quicklogRows={quicklogRows}
            plannedDepth={planned_depth}
            listVisualMaps={listVisualMaps}
            variant="print"
            trackHeightPx={20}
          />
          <PrintQuicklogStriplog
            quicklogRows={quicklogRows}
            listVisualMaps={listVisualMaps}
          />
        </div>
      </div>

      <div
        style={{
          width: LEFT_PANEL_WIDTH,
          flexShrink: 0,
          minHeight: 0,
        }}
        aria-hidden="true"
      />
    </div>
  );
};

export default PrintDrillingInProgressHole;
